// extracted by mini-css-extract-plugin
module.exports = {"btn_disabled":"outline_btn_disabled__1MVlI","btn":"outline_btn__3U-iL","btn_grey":"outline_btn_grey__2-CR0"};